/**
 * Task 17: Sync Wishlist by Square header counter visibility with app state.
 * Hides the badge when the app reports 0 items — does not override the count.
 */
(function () {
  var WISHLIST_PATH = '/apps/page/wishlist';
  var vitalsRequire;

  function getWishlistApi() {
    var chunks = window.rspackChunkvitalsLibrary;
    if (!chunks || typeof chunks.push !== 'function') return;

    if (!vitalsRequire) {
      chunks.push([
        [Date.now() + Math.floor(Math.random() * 10000)],
        {},
        function (runtime) {
          vitalsRequire = runtime;
        },
      ]);
    }

    if (!vitalsRequire || !vitalsRequire.m) return;

    var moduleId = Object.keys(vitalsRequire.m).find(function (id) {
      var source = String(vitalsRequire.m[id]);
      return source.indexOf('shop_id') !== -1 && source.indexOf('productId') !== -1 && source.indexOf('variantId') !== -1;
    });
    if (!moduleId) return;

    var module = vitalsRequire(moduleId);
    var functions = Object.values(module).filter(function (value) {
      return typeof value === 'function';
    });

    return {
      add: functions.find(function (fn) {
        var source = String(fn);
        return source.indexOf('shop_id') !== -1 && source.indexOf('productId') !== -1;
      }),
      list: functions.find(function (fn) {
        return String(fn).indexOf('URLSearchParams') !== -1;
      }),
      session: functions.find(function (fn) {
        var source = String(fn);
        return source.indexOf('isLoggedIn') !== -1 && source.indexOf('hash') !== -1;
      }),
    };
  }

  function waitForWishlistApi() {
    return new Promise(function (resolve, reject) {
      var started = Date.now();
      var poll = window.setInterval(function () {
        var api = getWishlistApi();
        if (api && api.add && api.list && api.session) {
          window.clearInterval(poll);
          resolve(api);
        } else if (Date.now() - started >= 12000) {
          window.clearInterval(poll);
          reject(new Error('Wishlist app is unavailable'));
        }
      }, 200);
    });
  }

  function setHeaderCounter(count) {
    document.querySelectorAll('.Vtl-WishlistHeader__HeartCounter').forEach(function (counter) {
      counter.textContent = String(count);
    });
    syncHeaderCounter();
  }

  window.trsAddToWishlist = async function (productId, variantId) {
    var api = await waitForWishlistApi();
    var session = await api.session();
    var items = await api.list(window.shopId, session.hash);
    var isSaved = items.some(function (item) {
      return String(item.variantId) === String(variantId) && !item.deleted;
    });

    if (!isSaved) await api.add(session.hash, Number(productId), Number(variantId));

    var updatedItems = await api.list(window.shopId, session.hash);
    setHeaderCounter(
      updatedItems.filter(function (item) {
        return !item.deleted;
      }).length
    );
  };

  function isWishlistPage() {
    return window.location.pathname.indexOf(WISHLIST_PATH) === 0;
  }

  function syncHeaderCounter() {
    document.querySelectorAll('.Vtl-WishlistHeader__HeartCounter').forEach(function (counter) {
      var count = parseInt((counter.textContent || '').trim(), 10);
      var isEmpty = Number.isNaN(count) || count <= 0;

      counter.style.display = isEmpty ? 'none' : '';
      counter.setAttribute('aria-hidden', isEmpty ? 'true' : 'false');
    });
  }

  function observeWishlist() {
    syncHeaderCounter();
    ensureWishlistSkeleton();
    enhanceEmptyWishlist();

    var root = document.querySelector('.header__icons') || document.body;
    if (!window.MutationObserver) return;

    new MutationObserver(syncHeaderCounter).observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    new MutationObserver(enhanceEmptyWishlist).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function ensureWishlistSkeleton() {
    if (!isWishlistPage() || document.querySelector('[data-trs-wishlist-loading]')) return;

    var main = document.getElementById('MainContent') || document.body;
    var loader = document.createElement('div');
    loader.className = 'trs-wishlist-loading page-width';
    loader.setAttribute('data-trs-wishlist-loading', '');
    loader.setAttribute('role', 'status');
    loader.setAttribute('aria-live', 'polite');
    loader.innerHTML =
      '<div class="trs-wishlist-loading__card">' +
        '<span class="trs-wishlist-loading__spinner" aria-hidden="true"></span>' +
        '<span class="trs-wishlist-loading__text">Loading your wishlist...</span>' +
      '</div>';

    main.prepend(loader);
    setTimeout(removeWishlistSkeletonIfReady, 4500);
  }

  function removeWishlistSkeletonIfReady() {
    var loader = document.querySelector('[data-trs-wishlist-loading]');
    if (!loader) return;

    var main = document.getElementById('MainContent') || document.body;
    var emptyText = findEmptyWishlistText();
    var appContent = document.querySelector(
      '.Vtl-WishlistPage, .Vtl-WishlistPageWrapper, [class*="WishlistPage"], [class*="wishlist-page"]'
    );
    var mainText = (main.textContent || '').replace((loader.textContent || ''), '').trim();

    if (emptyText || appContent || mainText.length > 20) loader.remove();
  }

  function findEmptyWishlistText() {
    return Array.prototype.find.call(document.querySelectorAll('h1, h2, h3, p, div, span'), function (el) {
      return (el.textContent || '').trim() === 'Your Wishlist is empty';
    });
  }

  function enhanceEmptyWishlist() {
    var emptyText = findEmptyWishlistText();
    removeWishlistSkeletonIfReady();

    if (!emptyText || document.querySelector('[data-trs-wishlist-empty-cta]')) return;

    var cta = document.createElement('a');
    cta.href = '/collections/all';
    cta.className = 'button trs-wishlist-empty-cta';
    cta.setAttribute('data-trs-wishlist-empty-cta', '');
    cta.textContent = 'Browse products';

    emptyText.insertAdjacentElement('afterend', cta);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeWishlist);
  } else {
    observeWishlist();
  }
})();
